import { useContext, useMemo } from 'react';
import type { MessageBlock, UIBlock } from '@trinity/chat';
import { AgentProgressContext } from './context';

function isMessageBlock(block: UIBlock | undefined): block is MessageBlock {
  return block?.kind === 'message';
}

export function useLatestAgentProgressMessageBlock(): MessageBlock | undefined {
  const progress = useContext(AgentProgressContext);

  return useMemo((): MessageBlock | undefined => {
    if (!progress) return undefined;

    const messageBlocks = Object.values(progress.blocks).filter((block): block is MessageBlock =>
      isMessageBlock(block)
    );
    if (messageBlocks.length === 0) return undefined;

    const latestStreaming = messageBlocks
      .filter((block) => block.streaming)
      .reduce<MessageBlock | undefined>((latest, current) => {
        if (!latest) return current;
        return current.updatedAt > latest.updatedAt ? current : latest;
      }, undefined);

    if (latestStreaming) return latestStreaming;

    return messageBlocks.reduce<MessageBlock | undefined>((latest, current) => {
      if (!latest) return current;
      return current.updatedAt > latest.updatedAt ? current : latest;
    }, undefined);
  }, [progress]);
}
